import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FC, ReactElement } from "react";

interface IEmployeeCardListItemProps {
  icon: ReactElement;
  text: string | null;
}

const EmployeeCardListItem: FC<IEmployeeCardListItemProps> = ({
  icon,
  text,
}) => (
  <ListItem
    sx={{
      width: "auto",
      borderRight: "1px solid rgba(0, 0, 0, 0.12)",
    }}
  >
    <ListItemIcon
      sx={{
        minWidth: "40px",
      }}
    >
      {icon}
    </ListItemIcon>
    <ListItemText
      primary={text || "-"}
      slotProps={{
        primary: {
          variant: "subtitle2",
          color: "text.secondary",
          sx: { fontWeight: 400 },
        },
      }}
    />
  </ListItem>
);

export default EmployeeCardListItem;
